module.exports = __webpack_public_path__ + "static/media/2.5ce9ab85.jpg";